(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class VitavaFilterPanel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        if (!event.target.closest('[data-close-filter-panel]')) return;
        this.querySelector('details')?.removeAttribute('open');
      });
    }
  }

  if (!customElements.get('vitava-filter-panel')) {
    customElements.define('vitava-filter-panel', VitavaFilterPanel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vitava-product-after-purchase"] && !Shopify.designMode) return;
  try {
    const initVitavaProductPurchaseActions = (scope = document) => {
    scope.querySelectorAll('[data-vitava-add-to-cart]').forEach((button) => {
      if (button.dataset.vitavaBound === 'true') return;
      button.dataset.vitavaBound = 'true';
      button.addEventListener('click', () => {
        const form = button.closest('.product-details')?.querySelector('product-form-component form');
        form?.requestSubmit();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initVitavaProductPurchaseActions());
  } else {
    initVitavaProductPurchaseActions();
  }

  document.addEventListener('shopify:section:load', (event) => initVitavaProductPurchaseActions(event.target));
  } catch(e) { console.error(e); }
})();

})();
